import { render } from "./Access.vue?vue&type=template&id=aa1f8e56&scoped=true"
import script from "./Access.vue?vue&type=script&lang=js"
export * from "./Access.vue?vue&type=script&lang=js"

import "./Access.vue?vue&type=style&index=0&id=aa1f8e56&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-aa1f8e56"

export default script